import { Divider } from "antd";
import SpepInstructionCard from "./step-instruction-card";

export default function SubmittalInstruction() {
  return (
    <div className="linking-group--right--content p-1 pr-12">
      <SpepInstructionCard
        title="Step 1:"
        detail="Select a Submittal from the dropdown."
      />
      <SpepInstructionCard
        title="Step 2:"
        detail="To associate a Material, click Edit to open a list here. You can associate an Activity to the Material here."
      />
      <SpepInstructionCard
        title="Step 3:"
        detail="Click Save to confirm changes."
      />
      <Divider />
      <SpepInstructionCard
        title="Note"
        detail="Activities can be associated directly to Submittals, by switching the Setting on."
      />
      <SpepInstructionCard
        title=""
        detail="Material tracking is enabled by default and can be switched off at any time."
      />
    </div>
  );
}
